export default "__VITE_PUBLIC_ASSET__0296b1d9__"